module.exports = __webpack_public_path__ + "img/028-madeira.99ade3d9.svg";